import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useProjeto } from '@/contexts/projeto-hook';
import { useI18n } from '@/contexts/i18n-hook';
import { SeletorGrupoTipo } from '@/components/templates/seletor-grupo-tipo';
import { EditorPartesTemplate } from '@/components/templates/editor-partes-template';

interface TemaSelecionado {
    id: string;
    nome: string;
    partes: any[];
}

export function ModelosPage() {
    const navigate = useNavigate();
    const { projeto } = useProjeto();
    const { t } = useI18n();
    const [tipoSelecionado, setTipoSelecionado] = useState<TemaSelecionado | null>(null);

    if (!projeto) {
        return (
            <div className="p-8 text-center text-gray-500">
                {t('templates.modelos.semProjeto')}
            </div>
        );
    }

    const handleTipoSelecionado = (tipo: any | null) => {
        setTipoSelecionado(tipo);
    };

    const handleSalvarPartes = (partesAtualizadas: any[]) => {
        if (tipoSelecionado) {
            setTipoSelecionado({
                ...tipoSelecionado,
                partes: partesAtualizadas
            });
            alert(t('templates.modelos.salvoSucesso'));
        }
    };

    return (
        <div className="space-y-6 max-w-5xl mx-auto">
            {/* Cabeçalho */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-0">
                <div className="flex items-center">
                    <button
                        onClick={() => navigate('/meus-templates')}
                        className="mr-4 p-2.5 rounded-lg text-schmersal-gray-medium hover:text-schmersal-blue hover:bg-schmersal-gray-light transition-colors duration-200"
                        title={t('templates.modelos.voltar')}
                    >
                        <ArrowLeft className="h-5 w-5" />
                    </button>
                    <div>
                        <h1 className="text-2xl md:text-3xl font-bold text-schmersal-blue dark:text-white">
                            {t('templates.modelos.titulo')}
                        </h1>
                        <p className="mt-1 text-sm text-schmersal-gray-medium dark:text-schmersal-gray-light">
                            {t('templates.modelos.subtitulo')}
                        </p>
                    </div>
                </div>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-schmersal-blue p-4 rounded-r-md">
                <p
                    className="text-sm text-blue-800 dark:text-blue-200"
                    dangerouslySetInnerHTML={{ __html: t('templates.modelos.ajuda') }}
                />
            </div>

            {/* Passo 1: Seleção de Grupo e Tipo */}
            <SeletorGrupoTipo
                projetoId={projeto.id}
                onTipoSelecionado={handleTipoSelecionado}
            />

            {/* Passo 2: Edição de Partes (Mostrado apenas se um Tipo estiver selecionado) */}
            {tipoSelecionado ? (
                <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                    <EditorPartesTemplate
                        tipoId={tipoSelecionado.id}
                        partesIniciais={tipoSelecionado.partes || []}
                        onSalvar={handleSalvarPartes}
                    />
                </div>
            ) : (
                <div className="text-center py-12 bg-white dark:bg-gray-800 rounded-xl border border-dashed border-gray-300 dark:border-gray-700 shadow-sm">
                    <p
                        className="text-gray-500 dark:text-gray-400"
                        dangerouslySetInnerHTML={{ __html: t('templates.modelos.vazio') }}
                    />
                </div>
            )}
        </div>
    );
}
